module.exports = __webpack_public_path__ + "static/media/ic_cities.d5736e38.svg";